import React from 'react'
import { useEffect } from 'react'

function DataLayer({ state }) {

    useEffect(() => {
	
	 	// let gtmId = document.getElementById("googleTagManagerId").getAttribute("value")
        // console.log("log in dataLayer gtmId",gtmId);
        // console.log("log in dataLayer window.google_tag_manager",window.google_tag_manager);
        // if(window.google_tag_manager){
        //     if(window.dataLayer){
        //         window.dataLayer = []
        //         window.google_tag_manager[gtmId].dataLayer.reset();
        //     }
           
        // }
        console.log("log in dataLayer", state);
        // handleSiteSpectScriptTrigging()
        window.dataLayer = window.dataLayer || []
        console.log('window.dataLayer ---- before - ', window.dataLayer)
        if (state && state.dataLayerObjectList && JSON.parse(state.dataLayerObjectList) && JSON.parse(state.dataLayerObjectList).pageDataLayerObj) {
            {JSON.parse(state.dataLayerObjectList).pageDataLayerObj.map((oneData) => {
               // console.log('oneData ---- outside condition ', oneData)    
                if (Object.keys(oneData).length != 0) {
                  //  console.log('oneData inside condition', oneData)
                        window.dataLayer.push(oneData)
                    }
                })
            }
        }
        console.log('window.dataLayer ---- after - ', window.dataLayer)
        // ssRecsInfo

        if (state && state.ssRecsInfoPageObj && state.ssRecsInfoPageObj.page && Object.keys(state.ssRecsInfoPageObj.page).length != 0) {
            window.ssRecsInfo = window.ssRecsInfo || {}
            window.ssRecsInfo = state.ssRecsInfoPageObj
            window.dispatchEvent(new CustomEvent("sitespect-user-action", { 'detail': state.ssRecsInfoPageObj }))
        }

        if (state && state.siteSpectUserAction &&  Object.keys(state.siteSpectUserAction).length != 0) {
            window.ssRecsInfo = window.ssRecsInfo || {}
            window.ssRecsInfo = state.siteSpectUserAction
            window.dispatchEvent(new CustomEvent("sitespect-user-action", { 'detail': state.siteSpectUserAction }))
        }

        
        // dataLayer_obj
        if (state && state.dataLayer_obj3 && Object.keys(state.dataLayer_obj3).length != 0) {
            window.dataLayer_obj = window.dataLayer_obj || {}
            window.dataLayer_obj = state.dataLayer_obj3
        }

        // cart rts
        if (state?.cartRtsData) {
           // console.log("dataLayer cartRtsData", state?.cartRtsData);
            window.dataLayer = window.dataLayer || []
            window.dataLayer.push(state?.cartRtsData)

        }
        if(document.getElementById("dataLayer")){
            document.getElementById("dataLayer").click()
        }
    }, [state])

    function handleSiteSpectScriptTrigging() {
        console.log("sitespect-user-action in useeffect");
        const head = document.getElementById("siteSpectScript");
        const script = document.createElement("script");
        let url = "/vaststatic/static-assets/common/resources/js/SiteSpect.js";
        if (url && head) {
            const scriptTags = head.getElementsByTagName('script');
            if (scriptTags) {
                [...scriptTags].forEach(tag => tag.remove());
            }
            script.setAttribute("src", url);
            script.setAttribute("async", true);
            head.appendChild(script);
        }

    }

    return (
        <div><p id="dataLayer" className='m-0'></p></div>
    )
}

export default DataLayer